import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import onDomReady from './onDomReady';

const swiper = new Swiper('.product-detail-gallery', {
	modules: [Navigation],
	slidesPerView: 'auto',
	spaceBetween: 0,
	centeredSlides: true,
	loop: true,
	grabCursor: true,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	effect: 'coverflow',
	coverflowEffect: {
		rotate: 0,
		stretch: 0,
		depth: 100,
		modifier: 1,
		slideShadows: false,
	},
});

onDomReady(() => {
	const arrow = document.querySelector('.product-detail-header-arrow');

	if (window.scrollY > 50) {
		arrow.style.animation = 'none';
	}

	window.addEventListener('scroll', function () {
		if (window.scrollY > 50) {
			arrow.style.animation = 'none';
		} else {
			arrow.style.animation = 'bounce 2s infinite';
		}
	});
});
